
import { OnboardingStep } from '@/types/onboarding';

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: 'welcome',
    title: 'Welcome',
    description: 'Welcome to InvenioCRM',
    component: 'WelcomeStep',
    component_name: 'WelcomeStep',
    estimatedTime: '2 min',
    estimated_time_minutes: 2,
    isOptional: false,
    isSkippable: false,
    is_required: true
  },
  {
    id: 'profile_and_organization',
    title: 'Setup Profile & Organization',
    description: 'Complete your profile and organization setup',
    component: 'ProfileAndOrganizationSetupStep',
    component_name: 'ProfileAndOrganizationSetupStep',
    estimatedTime: '5 min',
    estimated_time_minutes: 5,
    isOptional: false,
    isSkippable: false,
    is_required: true
  },
  {
    id: 'feature_tour',
    title: 'Feature Tour',
    description: 'Learn about key features',
    component: 'FeatureTourStep',
    component_name: 'FeatureTourStep',
    estimatedTime: '3 min',
    estimated_time_minutes: 3,
    isOptional: true,
    isSkippable: true,
    is_required: false
  },
  {
    id: 'agent_activation',
    title: 'Agent Activation',
    description: 'Activate your AI agents',
    component: 'AgentActivationStep',
    component_name: 'AgentActivationStep',
    estimatedTime: '2 min',
    estimated_time_minutes: 2,
    isOptional: true,
    isSkippable: true,
    is_required: false
  }
];

export const getStepByIndex = (index: number): OnboardingStep | undefined => {
  return ONBOARDING_STEPS[index];
};

export const getStepById = (stepId: string): OnboardingStep | undefined => {
  return ONBOARDING_STEPS.find(step => step.id === stepId);
};

export const getStepIndex = (stepId: string): number => {
  return ONBOARDING_STEPS.findIndex(step => step.id === stepId);
};

export const getNextStep = (currentStepId: string): OnboardingStep | undefined => {
  const currentIndex = getStepIndex(currentStepId);
  if (currentIndex === -1 || currentIndex >= ONBOARDING_STEPS.length - 1) {
    return undefined;
  }
  return ONBOARDING_STEPS[currentIndex + 1];
};
